import { useState } from "react";
function useStepData() {
  const [ignoreHeaders, setIgnoreHeaders] = useState([]);
  const [newData, setNewData] = useState([]);

  const reset = () => {
    setIgnoreHeaders([]);
    setNewData([]);
  };

  return {
    ignoreHeaders,
    setIgnoreHeaders,
    newData,
    setNewData,
    reset,
  };
}

export default useStepData;
